import React, { ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { SelfInvoiceTodoFormProps } from "models/propTypes/selfInvoicePropTypes";
//#endregion
//#region components
import { WintForm, useWintExpandableStep, useWintForm } from "components/common/wintForms";
import SelfInvoiceFormGeneralSectionExpandable from "./sections/generalSectionExpandable";
import SelfInvoiceFormItemsSection from "./sections/itemSection";
import { Grid } from "@mui/material";
import SelfInvoiceTodoFormDimensionsSection from "./sections/dimensionsSection";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const SelfInvoiceTodoForm: ForwardRefRenderFunction<FormHandles, SelfInvoiceTodoFormProps> = (props, ref) => {
  const { wintFormProps, connect, values, formState } = useWintForm<InvoiceFormTypes.SelfInvoiceTodo>({
    formRef: ref,
    defaultValues: props.defaultValues,
    validationSchema: props.validationSchema,
    validateOnMount: true,
    validateOnBlur: true,
    validateOnChange: false,
    handleSubmit: props.handleSubmit,
  });

  const expandableStepProps = useWintExpandableStep(formState);

  return (
    <WintForm {...wintFormProps}>
      <Grid container className={cssExports.sectionedForm} marginBottom={-2.5}>
        <SelfInvoiceFormGeneralSectionExpandable
          connect={connect}
          values={values}
          expandableStepProps={expandableStepProps}
        />
        <SelfInvoiceFormItemsSection
          connect={connect}
          values={values}
          expandableStepProps={expandableStepProps}
          interpretedTotalIncludingTax={props.invoice.totalAmount}
          interpretedItemsTotal={
            props.invoice.items?.map((row) => Number(row.totalAmountExVAT ?? 0)).reduce((x, y) => x + y, 0) ?? 0
          }
        />
        <SelfInvoiceTodoFormDimensionsSection
          connect={connect}
          values={values}
          expandableStepProps={expandableStepProps}
        />
      </Grid>
    </WintForm>
  );
};

export default React.forwardRef(SelfInvoiceTodoForm);
